<template lang="pug">
div
  v-card.mb-3
    v-card-title.title.grey.lighten-4
      template(v-if="extra && extra.options && extra.options.show_panel_title") {{extra.name}}
      v-spacer
      v-btn(v-if="user && user.uid" target="_blank" :href="`https://eur.delve.office.com/?u=${user.uid}&v=work`" color="primary")
        | Mein Office Profil
        v-icon(right) launch

  v-alert(:value="noPerson" type="error") Keinen passenden Eintrag in der Telefonliste gefunden.
  
  v-card.mb-3(v-if="person")
    v-card-title.title.grey.lighten-4
      span Meine Ausleihen.
    v-card.mb-3
      v-data-table(:items="ausleihen" :headers="ausleiheHeader" must-sort :pagination.sync="ausleihePagination")
        template(v-slot:items="{ item }")
          td {{ item.id }}
          td {{ person.vorname}}
          td {{ person.nachname}}
          td {{ item.hardware }}
          td {{ item.anzahl }}
          td {{ item.ausgeliehenAm }}
          td {{ item.geplanteAbgabe }}
          td {{ item.abgegebenAm }}

  v-card.mb-3(v-if="person")
    v-card-title.title.grey.lighten-4
      span Software Lizenzen
    v-card.mb-3
      v-data-table(:items="software" :headers="softwareListHeader" must-sort :pagination.sync="softwareListPagination")
        template(v-slot:items="{ item }")
          td {{ item.name}}
          td {{ item.publisher}}

  v-card.mb-3(v-if="person")
    v-card-title.title.grey.lighten-4
      span Password Reset
    v-card.mb-3
      v-card-text
        v-layout(wrap)
          v-flex(xs12 md6)
            v-text-field(label="Passwort" type="password" autocomplete="new-password")
          v-flex(xs12 md6)
            v-text-field(label="Passwort Bestätigung" type="password" autocomplete="new-password")
      v-card-actions(v-if="projekt")
          v-btn(outline color="primary" @click="changePassword") Passwort Ändern

  v-layout(wrap)
    v-flex(xs12 md6)
      v-card.mb-3(v-if="person")
        v-card-title.title.grey.lighten-4
          span E-Mail Signatur anpassen je Projekt
        v-card-text
          v-layout(wrap)
            v-flex(xs12)
              v-select(label="Projekt" box :items="projekte" v-model="projektId" item-text="name" item-value="id")
              v-checkbox(v-if="projekt" label="als Standardsignatur verwenden" v-model="projekt.signaturDefault" :disabled="projekt.signaturDefault" :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_default')")
            template(v-if="projekt")
              v-flex(xs12)
                v-select(label="Grußformel" v-model="projekt.signaturGrussformel" :items="signaturGrussformeln" clearable)
                p.signaturinformation
                  | Sind die Nummern falsch oder die Funktionsbeschreibung nicht zutreffend, melde dich bei der&#32;
                  a(href="mailto:verwaltung@hvd-bb.de?subject=Rufnummern/Funktion in Datenbank anpassen") Poststelle
                  |  (verwaltung@hvd-bb.de).
                v-checkbox(:label="`Titel Anzeigen (${person.titel})`" v-model="projekt.signaturZeigeTitel" hide-details :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_zeige_titel')")
                v-checkbox(:label="`Pronouns Anzeigen (${person.pronouns})`" v-model="projekt.signaturZeigePronouns" hide-details :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_zeige_pronouns')")
                v-checkbox(:label="`Telefon Anzeigen (${person.telefon})`" v-model="projekt.signaturZeigeTelefon" hide-details :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_zeige_telefon')")
                v-checkbox(:label="`Mobil Anzeigen (${person.mobil})`" v-model="projekt.signaturZeigeMobil" hide-details :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_zeige_mobil')")
                v-checkbox(:label="`Persönliche E-Mail Anzeigen (${person.email})`" v-model="projekt.signaturZeigePersoenlEmail" hide-details :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_zeige_persoenl_email')")
                v-checkbox(:label="`Projekt E-Mail Anzeigen (${projekt.email})`" v-model="projekt.signaturZeigeProjektEmail" hide-details :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_zeige_projekt_email')")
                v-text-field(label="Projekt E-Mail Überschreiben" v-model="projekt.signaturCustomProjektEmail" :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_custom_projekt_email')") 
              v-flex(xs12 md6)
                v-text-field(label="Projekt Website" v-model="projekt.signaturWebsite" :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_website')")
                v-text-field(label="Facebook" v-model="projekt.signaturSocialMedia1" :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_social_media_1')")
              v-flex(xs12 md6) 
                v-text-field(label="Twitter" v-model="projekt.signaturSocialMedia2" :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_social_media_2')")
                v-text-field(label="Youtube" v-model="projekt.signaturSocialMedia3" :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_social_media_3')")
              v-flex(xs12): v-textarea(label="freies Informationsfeld für Öffnungszeiten, 'Im Auftrag von...', etc." v-model="projekt.signaturInfofeld" box :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_infofeld')")
              v-flex(xs12): file-input(label="Zusätzliches Bild/Logo neben Projektlogo" v-model="projekt.signaturZusatzlogoName" :url="projekt.signaturZusatzlogo" hide-name clearable base64 @base64="projekt.signaturZusatzlogo = $event" :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_zusatzlogo')")
              v-flex(xs12)
                p.signaturinformation 
                  | Das Bild wird erst nach dem Speichern in der Vorschau angezeigt.
              v-flex(xs12 md6)
                v-radio-group(v-model="bildauswahl")
                  v-radio(value="banner" v-on:change="projekt.signaturWerbebildUseDefault = true; signaturEigenesBildNutzen = false" :label="`HVD Banner anzeigen (verschiedene verfügbar)`")
                  v-radio(value="eigen" v-on:change="projekt.signaturWerbebildUseDefault = false; signaturEigenesBildNutzen = true" :label="`Eigenen Banner/Eigenes Bild hochladen`")
                  v-radio(value="ohne" v-on:change="projekt.signaturWerbebildUseDefault = false; signaturEigenesBildNutzen = false; projekt.signaturWerbebild = null" :label="`Ohne`")
              template(v-if="projekt.signaturWerbebildUseDefault")
                v-flex(xs12 md6)
                  v-dialog(width="500" v-model="auswahlbilddialog")
                    template(v-slot:activator='{ on }')
                      v-btn(color='normal' v-on='on')
                        | Banner wählen
                    v-list
                      v-list-tile(v-for='(item) in signaturAuswahlbilder' @click='projekt.signaturAuswahlbildId = item.id; auswahlbilddialog = false').bannersizevielkomplizierter
                        img(:src="item.bild" style="max-height: 100px")
              template(v-if="!projekt.signaturWerbebildUseDefault && signaturEigenesBildNutzen")
                v-flex(xs12 md6)
                  v-flex(xs12): file-input(label="Eigenen Banner/Eigenes Bild" v-model="projekt.signaturWerbebildName" :url="projekt.signaturWerbebild" hide-name clearable base64 @base64="projekt.signaturWerbebild = $event" :error-messages="gqlErrorsFor('personenProjektUpdate', 'signatur_werbebild')" v-if="!projekt.signaturWerbebildUseDefault")
                  v-flex(xs12)
                    p.signaturinformation 
                      | Das Bild wird erst nach dem Speichern in der Vorschau angezeigt.               

        v-card-actions(v-if="projekt")
          v-btn(outline color="primary" large @click="save" :disabled="!projektChanged" :loading="loading > 0") Speichern
        v-card-text
          p.signaturinformation
            | Die Signaturen werden beim nächsten Neustart des Computers in Outlook übernommen. 

    v-flex(xs12 md6)
      template(v-for="vorschau in vorschauen" v-if="person && projekt")
        v-card.mb-3
          v-card-title.title.grey.lighten-4
            span Vorschau {{vorschau.art}}
            v-spacer
            v-menu.mr-3(offset-y open-on-hover)
              v-btn(slot="activator" icon)
                v-icon vertical_align_bottom
              v-list
                v-list-tile(@click="copyToClipboard(vorschau)"): v-list-tile-title In Zwischenablage Kopieren
          v-card-text
            div(v-html="vorschau.html")
</template>
<style lang="stylus">
  .bannersizevielkomplizierter .v-list__tile {
    height: 110px !important
  }

  .signaturinformation {
    color: rgba(0,0,0,0.54);
    font-family: 'Roboto', sans-serif;
    display: inline-block;
  }
</style>

<script>
import { user } from '../../router'
import { sortBy } from 'lodash'
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import clipboard from 'clipboard-polyfill'
import stringReplaceAsync from 'string-replace-async'
import Vue from 'vue'
import { debounce } from 'lodash'

const imgSrc2base64 = function(html, base64 = true) {
  return stringReplaceAsync(html, /src="([^"]*)"/g, async (_, src) => {
    if (/^\/([^\/]|$)/.test(src)) {
      src = `${location.origin}${src}`
    }
    if (base64) {
      try {
        const img = await (await Vue.http.get(src, { responseType: 'blob' })).blob()
        src = await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.addEventListener('load', () => {
            resolve(reader.result)
          }, false)
          reader.addEventListener('error', () => {
            reject(reader.error)
          }, false)

          reader.readAsDataURL(img)
        })
      } catch(e) {
      }
    }

    return `src="${src}"`
  })
}

export default {
  mixins: [GraphqlErrorObject],
  props: ['extra'],
  data() {
    return {
      user,
      loading: 0,
      person: null,
      noPerson: false,
      projekt: null,
      projektId: null,
      projekte: [],
      signaturGrussformeln: [],
      signaturAuswahlbilder: [],
      auswahlbilddialog: false,
      signaturEigenesBildNutzen: false,
      
      ausleiheHeader: [
        { text: 'ID', value: 'id' },
        { text: 'Vorname', value: 'vorname' },
        { text: 'Nachname', value: 'nachname' },
        { text: 'Hardware', value: 'hardware' },
        { text: 'Anzahl', value: 'anzahl' },
        { text: 'Ausgeliehen am', value: 'ausgeliehen_am' },
        { text: 'Geplante Abgabe', value: 'geplante_abgabe' },
        { text: 'Abgegeben am', value: 'abgegeben_am' },
      ],
      softwareListHeader: [
        { text: 'Name', value: 'name' },
        { text: 'Publisher', value: 'publisher'},
      ],
      ausleihePagination: {
        sortBy: 'nachname'
      },
      softwareListPagination: {
        sortBy: 'name'
      }
    }
  },
  apollo: {
    currentUser: {
      query: gql`query ExtraMeinProvilVue {
        currentUser {
          id
          person {
            id
            email
            titel
            pronouns
            anrede
            vorname
            nachname
            telefon
            mobil
            personenProjekte {
              id
              signaturDefault
              signaturFunktion
              signaturGrussformel
              signaturInfofeld
              signaturSocialMedia1
              signaturSocialMedia2
              signaturSocialMedia3
              signaturWebsite
              signaturZeigeMobil
              signaturZeigeProjektEmail
              signaturZeigePersoenlEmail
              signaturCustomProjektEmail
              signaturZeigeTelefon
              signaturZeigeTitel
              signaturZeigePronouns
              signaturWerbebildUseDefault
              signaturWerbebild(size: "x100")
              signaturZusatzlogo(size: "x100")
              signaturAuswahlbildId
              projekt {
                id
                logo(size: "100x100")
                fax
                telefon
                name
                email
                website
                standort {
                  ort
                  plz
                  strasse
                  hausnummer
                }
              }
            }
            ateraAgents {
              id
              hardware: agentName
            }
            ausleihen {
              id
              hardware
              anzahl
              ausgeliehenAm
              geplanteAbgabe
              abgegebenAm
            }
            lizenzen
            softwareListPersonen {
              softwareList {
                id
                name
                publisher
              } 
            }
          }
        }
      }`,
    },
    signaturGrussformeln: {
      query: gql`query ExtraMeinProvilVueGrussformeln {
        signaturGrussformeln
      }`
    },
    signaturAuswahlbilder: {
      query: gql`query ExtraMeinProvilVueAuswahlbilder {
        signaturAuswahlbilder {
          id
          bild(size: "x100")
        }
      }`
    }
  },
  asyncComputed: {
    async vorschauen() {
      if (this.person && this.person.email && this.projekt) {
        const vorschau = {
          signatur_grussformel: this.projekt.signaturGrussformel,
          signatur_zeige_titel: this.projekt.signaturZeigeTitel,
          signatur_zeige_pronouns: this.projekt.signaturZeigePronouns,
          signatur_zeige_telefon: this.projekt.signaturZeigeTelefon,
          signatur_zeige_mobil: this.projekt.signaturZeigeMobil,
          signatur_zeige_projekt_email: this.projekt.signaturZeigeProjektEmail,
          signatur_zeige_persoenl_email: this.projekt.signaturZeigePersoenlEmail,
          signatur_custom_projekt_email: this.projekt.signaturCustomProjektEmail,
          signatur_website: this.projekt.signaturWebsite,
          signatur_social_media_1: this.projekt.signaturSocialMedia1,
          signatur_social_media_2: this.projekt.signaturSocialMedia2,
          signatur_social_media_3: this.projekt.signaturSocialMedia3,
          signatur_infofeld: this.projekt.signaturInfofeld,
          signatur_werbebild_use_default: this.projekt.signaturWerbebildUseDefault,
          signatur_auswahlbild_id: this.projekt.signaturAuswahlbildId
        }
        return new Promise((resolve, reject) => {
          return this.vorschauenDebounce(vorschau, this.person.email, this.projekt.projektId, resolve, reject)   
        }) 
      } else {
        return []
      }
    },
  },
  watch: {
    projektId: {
      initial: true,
      handler(id) {
        const projekt = this.projekte && this.projekte.find(p => p.id === id)
        this.projekt = { ...projekt }
      }
    },
    currentUser(user) {
      if (user && user.person) {
        const personData = user.person
        const person = {}
        person.email = personData.email || ''
        person.titel = personData.titel || ''
        person.pronouns = personData.pronouns || ''
        person.vorname = personData.vorname || ''
        person.nachname = personData.nachname || ''
        person.telefon = personData.telefon || ''
        person.mobil = personData.mobil || ''
        person.ausleihen = personData.ausleihen || []
        person.ateraAgents = personData.ateraAgents || []
        person.softwareListPersonen = personData.softwareListPersonen || []
        person.lizenzen = personData.lizenzen || []
        this.person = person
        this.noPerson = false
        if (personData.personenProjekte) {
          const projekte = personData.personenProjekte.map(personenProjekt => {
            const projekt = personenProjekt.projekt
            const standort = projekt.standort || {}
            return {
              id: personenProjekt.id,
              projektId: projekt.id,
              name: projekt.name || '',
              signaturDefault: personenProjekt.signaturDefault,
              signaturZeigeMobil: personenProjekt.signaturZeigeMobil,
              signaturZeigeProjektEmail: personenProjekt.signaturZeigeProjektEmail,
              signaturZeigePersoenlEmail: personenProjekt.signaturZeigePersoenlEmail,
              signaturCustomProjektEmail: personenProjekt.signaturCustomProjektEmail,
              signaturZeigeTelefon: personenProjekt.signaturZeigeTelefon,
              signaturZeigeTitel: personenProjekt.signaturZeigeTitel,
              signaturZeigePronouns: personenProjekt.signaturZeigePronouns,
              signaturFunktion: personenProjekt.signaturFunktion,
              signaturGrussformel: personenProjekt.signaturGrussformel,
              signaturInfofeld: personenProjekt.signaturInfofeld,
              signaturWebsite: personenProjekt.signaturWebsite,
              signaturSocialMedia1: personenProjekt.signaturSocialMedia1,
              signaturSocialMedia2: personenProjekt.signaturSocialMedia2,
              signaturSocialMedia3: personenProjekt.signaturSocialMedia3,
              signaturZusatzlogoName: personenProjekt.signaturZusatzlogo ? "zusatzlogo" : null,
              signaturZusatzlogo: personenProjekt.signaturZusatzlogo,
              signaturWerbebildUseDefault: personenProjekt.signaturWerbebildUseDefault,
              signaturWerbebildName: personenProjekt.signaturWerbebild ? "werbebild" : null,
              signaturWerbebild: personenProjekt.signaturWerbebild,
              signaturAuswahlbildId: personenProjekt.signaturAuswahlbildId,
              logo: projekt.logo,
              fax: projekt.fax || '',
              telefon: projekt.telefon || '',
              email: projekt.email || '',
              website: projekt.website || '',
              ort: standort.ort || '',
              plz: standort.plz || '',
              strasse: standort.strasse || '',
              hausnummer: standort.hausnummer || '',
            }
          })
          this.projekte = sortBy(projekte, 'name')
          if (!this.projektId) {
            const projektId = this.projekte.find(projekt => projekt.signaturDefault) || this.projekte[0]
            this.projektId = projektId && projektId.id || null
          }
        } else {
          this.projekte = []
        }
      } else if (user) {
        this.noPerson = true
      }
    }
  },
  computed: {
    ausleihen() {
      return [].concat(this.person && this.person.ausleihen, this.person && this.person.ateraAgents)
    },
    software() {
      const list = this.person.softwareListPersonen.map((s) => s.softwareList)
      const lizenzen = this.person.lizenzen.map((l) => ({ id: l, name: l, publisher: "Microsoft" }))
      return [].concat(lizenzen, list)
    },
    projektChanged() {
      const neu = this.projekt
      if (neu) {
        const old = this.projekte.find(p => p.id == neu.id)
        return !Object.entries(neu).every(([name, value]) => old[name] === value)
      }
      return false
    },
    bildauswahl: {
            get () {
              if (this.projekt.signaturWerbebildUseDefault === true) {
                return 'banner' //  Fall Banner nutzen
              } else if ( (!this.projekt.signaturWerbebildUseDefault && this.projekt.signaturWerbebild !== null) || this.signaturEigenesBildNutzen === true) {
                return 'eigen' // Fall eigenes Bild nutzen
              }
              else {
                return 'ohne'
              }   
            },
            set (val) {
                null            
            }
        }
  },
  methods: {
    changePassword() {
      alert("Passwort ändern im moment leider nicht möglich.")
    },
    vorschauenDebounce: debounce(async function(vorschau, email, projektId, resolve, reject) {
      try {
        const resp = await this.$http.get('/api/v1b/email_signaturen', { params: { email, projekt_id: projektId, vorschau } })
        const signaturen = await resp.json()
        resolve(signaturen.signaturen)
      }
      catch(error) {
        reject(error)
      }
    },500),
    enableProject(projekt) {
      this.projekte.forEach(project => {
        project.signaturDefault = project.id === projekt.id
      })
    },
    save() {
      this.loading++
      this.gqlClearAllErrors()
      this.$apollo.mutate({
        mutation: gql`mutation (
          $id: ID!
          $signaturDefault: Boolean
          $signaturFunktion: String
          $signaturGrussformel: String
          $signaturInfofeld: String
          $signaturSocialMedia1: String
          $signaturSocialMedia2: String
          $signaturSocialMedia3: String
          $signaturWebsite: String
          $signaturZeigeMobil: Boolean
          $signaturZeigeProjektEmail: Boolean
          $signaturZeigePersoenlEmail: Boolean
          $signaturCustomProjektEmail: String
          $signaturZeigeTelefon: Boolean
          $signaturZeigeTitel: Boolean
          $signaturZeigePronouns: Boolean
          $signaturWerbebildUseDefault: Boolean
          $signaturWerbebild: String
          $signaturZusatzlogo: String
          $signaturAuswahlbildId: String
        ) {
          personenProjektUpdate(
            id: $id
            signaturDefault: $signaturDefault
            signaturFunktion: $signaturFunktion
            signaturGrussformel: $signaturGrussformel
            signaturInfofeld: $signaturInfofeld
            signaturSocialMedia1: $signaturSocialMedia1
            signaturSocialMedia2: $signaturSocialMedia2
            signaturSocialMedia3: $signaturSocialMedia3
            signaturWebsite: $signaturWebsite
            signaturZeigeMobil: $signaturZeigeMobil
            signaturZeigeProjektEmail: $signaturZeigeProjektEmail
            signaturZeigePersoenlEmail: $signaturZeigePersoenlEmail
            signaturCustomProjektEmail: $signaturCustomProjektEmail
            signaturZeigeTelefon: $signaturZeigeTelefon
            signaturZeigeTitel: $signaturZeigeTitel
            signaturZeigePronouns: $signaturZeigePronouns
            signaturWerbebildUseDefault: $signaturWerbebildUseDefault
            signaturWerbebild: $signaturWerbebild
            signaturZusatzlogo: $signaturZusatzlogo
            signaturAuswahlbildId: $signaturAuswahlbildId
          ) {
              id
              signaturDefault
              signaturFunktion
              signaturGrussformel
              signaturInfofeld
              signaturSocialMedia1
              signaturSocialMedia2
              signaturSocialMedia3
              signaturWebsite
              signaturZeigeMobil
              signaturZeigeProjektEmail
              signaturZeigePersoenlEmail
              signaturCustomProjektEmail
              signaturZeigeTelefon
              signaturZeigeTitel
              signaturZeigePronouns
              signaturWerbebildUseDefault
              signaturWerbebild(size: "x100")
              signaturZusatzlogo(size: "x100")
              signaturAuswahlbildId
          }
        }`,
        variables: { ...this.projekt, signaturGrussformel: this.projekt.signaturGrussformel || null },
      }).then((response) => {
        this.loading--
        if (response.data.personenProjektUpdate && response.data.personenProjektUpdate.id) {
          if (this.projekt.signaturDefault) {
            this.enableProject(this.projekt)
          }
        }
      }, (error) => {
        this.gqlAddErrors(error)
        this.loading--
      })
    },
    async copyToClipboard(vorschau) {
      const html = await imgSrc2base64(vorschau.html, false)
      const dt = new clipboard.DT()
      dt.setData("text/plain", html)
      dt.setData("text/html", html)
      clipboard.write(dt)
    }
  }
}
</script>
